import { Injectable } from '@angular/core';
import { renderRichText } from '@storyblok/js';
import { ConversionFormat } from '../tools/convert/templates/conversion-template/conversion-template.component';

@Injectable({
  providedIn: 'root',
})
export class ConvertReplaceService {
  private allKeys = [
    { key: 'slug', type: 'slug' },
    { key: 'extension', type: 'extension' },
    { key: 'name', type: 'string' },
    { key: 'category', type: 'string' },
    { key: 'subCategory', type: 'string' },
    { key: 'longDescription', type: 'richText' },
    { key: 'shortDescription', type: 'string' },
    { key: 'convertIcon', type: 'image' },
    { key: 'uploadIcon', type: 'image' },
    { key: 'downloadIcon', type: 'image' },
    { key: 'mainVisual', type: 'image' },
    { key: 'ogImage', type: 'image' },
  ] as const;

  replace(text: string, fromFormat: ConversionFormat, toFormat?: ConversionFormat) {
    if (!text) return text;

    if (!fromFormat) return text;

    if (!toFormat) {
      this.allKeys.forEach(item => {
        const value = this.getReplaceValue(item, fromFormat);
        text = text.replaceAll(`{{format.${item.key}}}`, value);
      });
    } else {
      this.allKeys.forEach(item => {
        const fromValue = this.getReplaceValue(item, fromFormat);
        const toValue = this.getReplaceValue(item, toFormat);
        text = text.replaceAll(`{{fromFormat.${item.key}}}`, fromValue);
        text = text.replaceAll(`{{toFormat.${item.key}}}`, toValue);
      });
    }
    return text;
  }

  private getReplaceValue(item: (typeof this.allKeys)[number], format: ConversionFormat) {
    if (item.type === 'slug') return format.slug;
    if (item.type === 'extension') return format.slug.toUpperCase();
    if (item.type === 'string') return format.content[item.key];
    if (item.type === 'richText') return format.content[item.key] ? renderRichText(format.content[item.key]) : '';
    if (item.type === 'image') return format.content[item.key] ? format.content[item.key].filename : '';
  }
}
